import React from 'react';

function TathataLogoCheck() {
  /* eslint-disable max-len */
  return (
    <svg width="24" height="20" viewBox="0 0 24 20" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="50%" y1="99.425%" x2="50%" y2="-6.113%" id="a">
          <stop stopColor="#8C1436" offset="0%" />
          <stop stopColor="#8C1436" stopOpacity=".99" offset="1%" />
          <stop stopColor="#881B34" stopOpacity=".46" offset="49%" />
          <stop stopColor="#851F33" stopOpacity=".13" offset="83%" />
          <stop stopColor="#842132" stopOpacity="0" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g fillRule="nonzero" transform="translate(0 2)">
          <ellipse fill="#FFF" opacity=".5" cx="7.831" cy="7.447" rx="7.831" ry="7.447" />
          <path
            d="M7.83.132C3.58.132.13 3.415.13 7.447c0 4.033 3.45 7.315 7.694 7.315 4.242 0 7.693-3.282 7.693-7.315 0-4.032-3.444-7.315-7.686-7.315z"
            fill="#B1132F"
          />
          <ellipse fill="url(#a)" style={{ mixBlendMode: 'multiply' }} cx="7.831" cy="7.447" rx="7.402" ry="7.042" />
          <path
            d="M19.23 6.262l1.3-1.324h-4.163v-.78h-2.143v.787H8.986v-.787H6.85v.787H2.68L3.99 6.27h2.86v.544H4.17l1.307 1.28H6.85v8.83l2.136-.374V8.095h5.245v8.455l2.14.383V8.095h1.373L19.05 6.77h-2.68v-.508h2.862zm-10.244 0h1.954v.545H8.986v-.545zm5.245.545h-1.943v-.545h1.94l.007.545z"
            fill="#FFF"
          />
        </g>
        <g transform="translate(15.652 2)">
          <ellipse fill="#2AB759" cx="4.07" cy="4.144" rx="3.443" ry="3.506" />
          <path
            d="M4.122 0C1.847 0 0 1.88 0 4.198c0 2.317 1.847 4.197 4.122 4.197 2.276 0 4.123-1.88 4.123-4.197C8.245 1.88 6.398 0 4.122 0zm0 7.556C2.304 7.556.824 6.05.824 4.198S2.304.84 4.122.84 7.42 2.346 7.42 4.198c0 1.85-1.48 3.358-3.298 3.358z"
            fill="#FFF"
          />
          <path
            stroke="#FFF"
            strokeWidth=".522"
            fill="#FFF"
            d="M3.607 5.776l-1.52-1.548.43-.436L3.607 4.9l2.31-2.35.426.44z"
          />
        </g>
      </g>
    </svg>
  );
  /* eslint-enable */
}

export default TathataLogoCheck;



// WEBPACK FOOTER //
// ./src/common/icons/Tathata-Logo-Check.js